/* eslint-disable prettier/prettier */
import { combineReducers } from "redux";
import login from "./authReducers";
import { chatsReducer, selectedChatReducer } from './chatReducer';
import { countriesAPIReducer, statesAPIReducer } from "./countriesAPIReducer";
import { levelIncomeReducer, rewardIncomeReducer, taskIncomeReducer } from "./incomeReducers";
import { myLeadReducer } from "./leadReducers";
import { levelPointReducer, rewardPointReducer, taskPointReducer } from "./pointReducers";
import { myTeamReducer, teamRefferalReducer } from "./teamReducers";
import { withdrawReducer } from "./withdrawReducers";
const rootReducers = combineReducers({
    login,
    lead: myLeadReducer,
    selectedChat : selectedChatReducer,
    chats : chatsReducer,
    team: myTeamReducer,
    teamRefferal: teamRefferalReducer,
    levelIncome: levelIncomeReducer,
    rewardIncome: rewardIncomeReducer,
    taskIncome: taskIncomeReducer,
    levelPoint: levelPointReducer,
    rewardPoint: rewardPointReducer,
    taskPoint: taskPointReducer,
    withdrawHistory: withdrawReducer,
    countries: countriesAPIReducer,
    states: statesAPIReducer
})

export default rootReducers;